import React, { useRef as UseRef, useEffect as UseEffect, useState as UseState } from 'react';
import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuApp from '../../../components/Menu';
import constantsDesign from '../../../utils/constants';
import orderSingleService from '../../../services/orderSingleFix';
import AuthService from "../../../services/security/auth.service";
import constants from '../../../utils/constants';
import { useNavigate as UseNavigate, useLocation as UseLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

const generateIdClient = () => {
    const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numeros = '0123456789';
    const nuevoValor = [];

    for (let i = 0; i < 4; i++) {
        nuevoValor.push(letras[Math.floor(Math.random() * letras.length)]);
    }

    for (let i = 0; i < 4; i++) {
        nuevoValor.push(numeros[Math.floor(Math.random() * numeros.length)]);
    }

    for (let i = 0; i < 4; i++) {
        nuevoValor.push(letras[Math.floor(Math.random() * numeros.length)]);
    }

    return nuevoValor.join('');
};

const orderPage = () => {
    const location = UseLocation()
    const params = new URLSearchParams(location.search)
    let id = params.get("id");
    console.log('id-> ' + id)
    let navigate = UseNavigate();
    const boxRef = UseRef(null);
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month.toString().length === 1 ? '0' + month : month

    let day = date.getDate();
    day = day.toString().length === 1 ? '0' + day : day
    let hours = date.getHours();
    hours = hours.toString().length === 1 ? '0' + hours : hours
    let minutes = date.getMinutes();
    minutes = minutes.toString().length === 1 ? '0' + minutes : minutes
    let seconds = date.getSeconds();
    seconds = seconds.toString().length === 1 ? '0' + seconds : seconds
    let dateNow = `${year}${month}${day}-${hours}:${minutes}:${seconds}.531`
    const [field, setField] = UseState({
        11: generateIdClient(),
        453: 1,
        448: 'dmx220-1',
        447: 'D',
        452: '53',
        1: '',
        55: '',
        167: '',
        15: '',
        40: 2,
        54: '',
        38: '',
        44: '',
        60: dateNow,
        63: '',
        64: '',
        29501: 1,
        48: '',
        'response': ''
    });
    const [loading, setLoading] = UseState(false);

    UseEffect(() => {

        if (id) {
            const user = AuthService.getCurrentUser();
            orderSingleService.getOrderById(user.client, user.data.instance, id).then((response) => {
                let responseFields = response.data.fields;
                setField(prevState => ({
                    ...prevState,
                    11: responseFields.clOrdID,
                    453: responseFields.noPartyIDs,
                    448: responseFields.partyID,
                    447: responseFields.partyIDSource,
                    452: responseFields.partyRole,
                    1: responseFields.account,
                    55: responseFields.symbol,
                    167: responseFields.securityType,
                    15: responseFields.currency,
                    40: responseFields.ordType,
                    54: responseFields.side,
                    38: responseFields.orderQty,
                    44: responseFields.price,
                    60: responseFields.transactTime,
                    63: responseFields.settlType,
                    64: responseFields.settlDate,
                    29501: responseFields.tradeFlag,
                    48: responseFields.securityID,
                    'response': response.data.response
                }), []);


            })
        }
    }, [setField])

    const handleChange = (e, id) => {

        setField(prevState => ({
            ...prevState,
            [id]: e.target.value,
        }), []);

    }

    const sendOrder = () => {
        setLoading(true);
        const user = AuthService.getCurrentUser();

        let request = {
            "clOrdID": field[11],
            "noPartyIDs": field[453],
            "partyID": field[448],
            "partyIDSource": field[447],
            "partyRole": field[452],
            "account": field[1],
            "symbol": field[55],
            "securityType": field[167],
            "currency": field[15],
            "ordType": field[40],
            "side": field[54],
            "orderQty": field[38],
            "price": field[44],
            "transactTime": field[60],
            "settlType": field[63],
            "settlDate": field[64],
            "tradeFlag": field[29501],
            "securityID": field[48],
        }

        orderSingleService.save(constants.CLIENT, user.data.instance, request, id).then((response) => {
            setLoading(false);
            navigate(`/ordersFix`);
            window.location.reload();
        }).catch((error) => {
            console.log(error);
        });
    }


    return <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
        <div className="App">
            <CssBaseline />
            <header className="App-header">
                <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                    <Grid container xs={12} item>
                        <Grid container sx={{ m: 1 }} xs={12} item>
                            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                <Box sx={{ width: '100%' }}>
                                    <MenuApp />
                                    <br></br>
                                    <br></br>
                                    <div>
                                        <Box
                                            component="form"
                                            sx={{
                                                '& .MuiTextField-root': { m: 1, },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <Typography variant="h5">
                                                Alta Órden FIX
                                            </Typography>
                                            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />

                                            {loading && <CircularProgress />}
                                            {!loading && (
                                                <Button variant='outlined' onClick={() => navigate('/ordersFix')}>Volver</Button>

                                            )}
                                            {!loading && id == null && (
                                                <Button variant='outlined' onClick={() => sendOrder()}>Enviar órden</Button>
                                            )}
                                            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                            <div className="mi-componente-material-ui">
                                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                                    <Grid item>
                                                        <TextField
                                                            id='11'
                                                            label='11 ClOrdID'
                                                            variant="outlined"
                                                            value={field[11]}
                                                            onChange={(event) => handleChange(event, 11)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='453'
                                                            label='453 NoPartyIDs'
                                                            variant="outlined"
                                                            value={field[453]}
                                                            onChange={(event) => handleChange(event, 453)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='448'
                                                            label='448 PartyID'
                                                            variant="outlined"
                                                            value={field[448]}
                                                            onChange={(event) => handleChange(event, 448)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='447'
                                                            label='447 PartyID Source'
                                                            variant="outlined"
                                                            value={field[447]}
                                                            onChange={(event) => handleChange(event, 447)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='452'
                                                            label='452 Party Role'
                                                            variant="outlined"
                                                            value={field[452]}
                                                            onChange={(event) => handleChange(event, 452)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='1'
                                                            label='1 Account'
                                                            variant="outlined"
                                                            value={field[1]}
                                                            onChange={(event) => handleChange(event, 1)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='55'
                                                            label='55 Symbol'
                                                            variant="outlined"
                                                            value={field[55]}
                                                            onChange={(event) => handleChange(event, 55)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='167'
                                                            label='167 SecurityType'
                                                            variant="outlined"
                                                            value={field[167]}
                                                            onChange={(event) => handleChange(event, 167)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='15'
                                                            label='15 Currency'
                                                            variant="outlined"
                                                            value={field[15]}
                                                            onChange={(event) => handleChange(event, 15)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='40'
                                                            label='40 OrdType'
                                                            variant="outlined"
                                                            value={field[40]}
                                                            onChange={(event) => handleChange(event, 40)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='54'
                                                            label='54 Side'
                                                            variant="outlined"
                                                            value={field[54]}
                                                            onChange={(event) => handleChange(event, 54)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='38'
                                                            label='38 OrderQty'
                                                            variant="outlined"
                                                            value={field[38]}
                                                            onChange={(event) => handleChange(event, 38)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='44'
                                                            label='44 Price'
                                                            variant="outlined"
                                                            value={field[44]}
                                                            onChange={(event) => handleChange(event, 44)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='60'
                                                            label='60 TransactTime'
                                                            variant="outlined"
                                                            value={field[60]}
                                                            onChange={(event) => handleChange(event, 60)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='63'
                                                            label='63 SettlType'
                                                            variant="outlined"
                                                            value={field[63]}
                                                            onChange={(event) => handleChange(event, 63)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='64'
                                                            label='64 SettlDate'
                                                            variant="outlined"
                                                            value={field[64]}
                                                            onChange={(event) => handleChange(event, 64)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='29501'
                                                            label='29501 Trade Flag'
                                                            variant="outlined"
                                                            value={field[29501]}
                                                            onChange={(event) => handleChange(event, 29501)}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <TextField
                                                            id='48'
                                                            label='48 SecurityID'
                                                            variant="outlined"
                                                            value={field[48]}
                                                            onChange={(event) => handleChange(event, 48)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <TextField
                                                        id='response'
                                                        label='Response'
                                                        variant="outlined"
                                                        value={field['response']}
                                                        multiline
                                                        disabled
                                                    />
                                                </Grid>
                                            </div>
                                        </Box>
                                    </div>
                                </Box>
                            </ThemeProvider>
                        </Grid>
                    </Grid>
                </Box>
            </header>
        </div>
    </ThemeProvider>
}


export default orderPage;